export default __webpack_public_path__ + "static/media/right.55bf6438.png";